export default "__VITE_ASSET__BWhgrjFo__"